<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import { mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { get } from 'lodash';
import logo from '@/assets/plans/logo_zoom_enhanced_media.svg';

export default {
  name: 'ZoomEnhancedMediaAddon',
  mixins: [base],
  for: () => {
    return false;
  },
  data() {
    return {
      logo,
      title: this.$t('billing.zoom_enhanced_media.title'),
      planType: planTypes.ZOOM_ENHANCED_MEDIA,
      description: this.$t('billing.zoom_enhanced_media.desc'),
    }
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return this.planMapFlat.filter((p) => p.type === planTypes.ZOOM_ENHANCED_MEDIA);
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
  },
};
</script>
